export default {
  path: "/automatic-processes",
  name: "automatic-processes",
  component: () =>
    import(
      /* webpackChunkName: "AutomaticProcesses" */ "@/views/modules/automatic_processes/index.vue"
    ),
  redirect: {
    name: "cut-and-reconnection"
  },
  meta: {
    auth: true,
    title: "Automatic Processes"
  },
  children: [
    {
      path: "cut-and-reconnection",
      alias: "cut-and-reconnection/",
      name: "cut-and-reconnection",
      redirect: {
        name: "record"
      },
      component: {
        name: "CutAndReconnection",
        render: (h) => h("router-view")
      },
      meta: {
        auth: true,
        title: "Cut and Reconnection"
      },
      children: [
        {
          path: "exonerated",
          name: "exonerated",
          component: () =>
            import(
              /* webpackChunkName: "Exonerated" */ "@/views/modules/automatic_processes/cut_and_reconnection/Exonerated.vue"
            ),
          meta: {
            auth: true,
            title: "Exonerated",
            index: true
          }
        },
        {
          path: "record",
          name: "record",
          component: () =>
            import(
              /* webpackChunkName: "Record" */ "@/views/modules/automatic_processes/cut_and_reconnection/Record.vue"
            ),
          meta: {
            auth: true,
            title: "Cut and Reconnection Record",
            index: true
          }
        }
      ]
    }
  ]
};
